import { urlHomepageBackground } from './urlConstants';
/*
CUSTOM CATEGORY PAGE CONFIGURATION
'route-name-for-page': { // object for custom category page. This is the route name for page. use dashes for spaces
  productCategories: [ // Set which product categories to include in the page. Can be subsets of main queries
    'wine'
    'wine-cabernet'
    'gifts'
  ]
  seoTitle: '' // Set the HTML title of the page for SEO
  description: '' // Set the text that displays at the top of the page
  category options: // Set which side navigation category to use on the page
    'wine'
    'gift'
    'coffee'
    'gifts-best-selling'
  filterCategory options: // Set which filter setting to use on page
    'wine' ( shows wine filters only )
    'gift' ( shows gift filters only )
    'cause-price' ( shows cause and price filters only )
    'none' ( hide filters )
  productsOnly: [] // Set which products to only show from within the set productCategories. Array of productIds and commented product name. Only use this or productsExlude
    '15b29dc0-27e0-4527-beda-01f1b09babe6', // Brut Sparkling
  ]
  productsExclude: [] // Set which products to exclude from within the set productCategories. Array of productIds and commented product name. Only use this or productsOnly
    '15b29dc0-27e0-4527-beda-01f1b09babe6', // Brut Sparkling
  ]
  topBanner: {
      imgSrc: `${urlHomepageBackground}hero-naughty-and-nice-2018.png`,
      imgSrcMobile: `${urlHomepageBackground}hero-naughty-and-nice-2018_mobile.png`,
      imgHeight: 200,
      imgWidth: 2250,
      imgHeightMobile: 200,
      imgWidthMobile: 639,
      imgAlt: 'Naughty and Nice gifts',
      imgLink: '/impact',
      linkCategory: 'naughty-and-nice',
      backgroundColor: '#FFFFFF',
    },
  bottomBanner: { // Set a specific banner to show on the page
    imgSrc: `${urlHomepageBackground}hero_flashsale.jpg`,
    imgSrcMobile: `${urlHomepageBackground}hero_flashsale_mobile.jpg`,
    imgHeight: 607,
    imgHeightMobile: 700,
    imgWidth: 1943,
    imgWidthMobile: 640,
    imgAlt: 'Glitter Bottle Sale, Save up to $195',
    imgLink: '/shop/flash-sale',
    linkCategory: 'flash-sale',
    backgroundColor: '#FFFFF',
  },
}
*/

const wines = {
  brut: '15b29dc0-27e0-4527-beda-01f1b09babe6', // Vintner Brut
  brutCelebrationGlitterGold: '791b3d82-4fad-4466-8511-bc1afbe026b8', // Brut Celebration Glitter Gold
  brutCelebrationGlitterSilver: 'd9d7b9c4-28b1-4ef4-8cc1-e63489d2a5bb', // Brut Celebration Glitter Silver
  brutGlitterRainbow: '569b016d-aee4-4196-8dd9-526cdba57e22', // Brut Glitter Rainbow
  brutShimmerGold: 'b4210b34-0c4d-4e6d-8e96-12cb61340790', // Brut Shimmer Gold
  brutShimmerSilver: '175d0511-7951-4aea-a6a8-ac16ebfb2371', // Brut Shimmer Silver
  cabMagnum: 'e8ddd5cc-d668-4ecf-9546-9cbcbf246b59', // 1.5L Cab
  chardonnay: '5fa97b97-9b0c-4c4c-89ba-8458e2b4a856', // Vintner Chardonnay
  cotesDeProvenceRose: '46fec98a-e1df-4267-98b9-b60839d163a6', // Côtes Rosé
  estateCab1: '3a6488b1-dca5-4283-b1df-f3c6892997c0', // Estate Cab 1 & 5
  estateCab2: 'c1ae37ad-8d18-4dea-93fb-b20e94661c47', // Estate Cab 2
  howellCab: '4b795e81-8592-476e-a3c2-b61aa8b9c094', // Howell Mountain
  oakvilleCab: 'b1297bd5-a688-4575-b23c-d3cff95f2fc6', // Oakville Cab
  tenYrCaliCab: '692c78e5-61a1-4101-9144-fe1e091b22c0', // 10Yr Cali Cab
  tenYrNapaCab: 'af5e5169-80d0-440a-8fe9-62f716f73326', // 10Yr Napa Cab
};

const giftBox = {
  awwBaby: '5f740ea9-c7b5-49c6-b5e4-860acd1fe2f8', // Aww Baby Gift 19
  californian: 'df547e1f-a9d4-443d-9f12-9f84eb86f3c8', // Californian 19
  celebration: 'fd595b34-674d-497c-8c38-c8f077fdf881', // Celebration 19
  cookiesCab: '29b5a039-c04a-484f-b9a8-3d0d23cb33c8', // Cookies & Cab 19
  frose: 'cc6b1cd3-3d47-4904-b619-5fecc7cb9904', // Frosé 19
  givingKeys: '017cd2a7-7133-4de1-b38c-71cb02eaf7ba', // The Giving Keys 19
  greenThumb: 'ddfe88f5-aff9-4472-aa8e-3909aa45ac75', // Green Thumb 19
  meow: 'efb7090e-4a68-4c75-8e8d-5fe5028966e6', // Meow Box 19 Pinot Noir
  mixologist: 'b33be712-c3de-4cb9-be95-bb485625a270', // Mixologist 19
  peppermint: '069adc4b-521d-45c8-aeb9-d62137aaed35', // Peppermint
  redWine: '810bcf17-2032-4279-84f8-b871cc783bdc', // Red Wine 18
  roseMacrame: '66c4fd06-a33d-4ba5-b084-8b071f299c22', // Rosé & Macrame 19
  singleMag: '2d1acd3e-f87f-46b1-b520-52ed70195165', // Single Bottle Magnetic Gift Box
  twoMag: '32f6c966-2238-49cd-9b40-e0085111b586', // Two Bottle Magnetic Gift Box
  whiteWine: '33c428da-7d65-4913-9a7e-6781d8c2fc02', // White Wine 18
  wineGrind: 'ee542e78-1f7e-4804-89d6-f59eb62b9fe2', // Wine & Grind 19
  wineHydrate: '6103efb4-ef2a-4769-8a6a-e07de0b5b136', // Wine & Hydrate
  woof: '45ac62c5-8b69-4740-9f8c-75a72447cff2', // Woof Box 19 Pinot Noir
  worldGood: '858b2d6e-d2b4-43a4-95c1-061af25b9f6a', // World Good 19
  mothersDaySingleBox19: '6d0aec9d-4043-498d-b5c3-a5e53c0191a9', // Mother's Day 2019 Single Wood Box
  mothersDayDoubleBox19: '00b7a0c0-499a-4f06-907f-790fbd3de7c9', // Mother's Day 2019 Double Wood Box
};

const giftCrate = {
  deluxeDuo: 'b5771b45-5bf2-4b60-bd68-5f4c051562c6', // Deluxe Duo
  picnicPerfect: '588a7773-dd2d-4e37-821c-61f57393e4fb', // Picnic Perfect
  wineCheese: 'a802ca92-6431-469d-8756-e42fb39c421f', // Wine Cheese 19
};

const merch = {
  goldWaterBottle: 'efbddbed-2fad-44f8-bf08-236bdaa21e60', // Gold Water Bottle
};

const banner = {
  topBanner: {
    imgSrc: `${urlHomepageBackground}Virtual-Tasting-Main-Banner_desk.png`,
    imgSrcTablet: `${urlHomepageBackground}Virtual-Tasting-Main-Banner_tablet.png`,
    imgSrcMobile: `${urlHomepageBackground}Virtual-Tasting-Main-Banner_mobile.png`,
    imgHeight: 504,
    imgWidth: 2272,
    imgHeightTablet: 448,
    imgWidthTablet: 1538,
    imgHeightMobile: 1048,
    imgWidthMobile: 1280,
    imgAlt: 'Virtual Tasting',
    imgLink: 'https://www.facebook.com/pg/onehopewine/events/',
    // linkCategory: '',
    backgroundColor: '#FFFFFF',
  },
};

export const customPCPConfig = {
  /*
  Permanent Pages
  */
  // sale: {
  //   productCategories: ['wine'],
  //   category: 'sale',
  //   seoTitle: 'SALE',
  //   description: 'SPRING SALE',
  //   filterCategory: 'none',
  //   productsOnly: [
  //     'c0f6be9a-2232-4d82-a764-44134c375e38', // Sunshine Sips 6-Pack
  //     'f66443a8-7da0-4d26-8ba1-3d492e402a12', // Patio Picks 6-Pack
  //     '54529efc-0c28-4440-a5e8-7b904d9ceb1f', // Sunshine Sips 12-Pack
  //     '992ac086-e239-466d-acdd-6babf39cedb4', // Patio Picks 12-Pack
  //     'b5904c99-f67e-420d-b218-5ee22a3341a0', // Sunshine Sips & Patio Picks 6-Pack
  //   ],
  //   // topBanner: {
  //   //   imgSrc: `${urlHomepageBackground}SpringSale19_category_enddate_desktop.jpg`,
  //   //   imgSrcMobile: `${urlHomepageBackground}SpringSale19_category_enddate_mobile.jpg`,
  //   //   imgHeight: 200,
  //   //   imgWidth: 1190,
  //   //   imgHeightMobile: 240,
  //   //   imgWidthMobile: 320,
  //   //   imgAlt: 'Sip into Spring Sale!',
  //   //   imgLink: '/the-grapeful-club',
  //   //   linkCategory: 'sip-into-spring-sale',
  //   //   backgroundColor: '#FFFFFF',
  //   // },
  // },
  // 'may-20': {
  //   productCategories: ['wine'],
  //   category: 'may-20',
  //   filterCategory: 'wine',
  //   seoTitle: 'May 20',
  //   description: 'MAY 20 TASTING: ORDER BY 5/10',
  //   productsOnly: [
  //     '633351c2-a9a3-4c43-bfc9-470d3253756d', // Paso Robles Reserve Cabernet Sauvignon
  //     '5fa97b97-9b0c-4c4c-89ba-8458e2b4a856', // Vintner Collection California Chardonnay
  //   ],
  //   topBanner: {
  //     imgSrc: `${urlHomepageBackground}Virtual-Tasting-Main-Banner_desk.jpg`,
  //     imgSrcTablet: `${urlHomepageBackground}Virtual-Tasting-Main-Banner_desk.jpg`,
  //     imgSrcMobile: `${urlHomepageBackground}Virtual-Tasting-Main-Banner_mobile.jpg`,
  //     imgHeight: 200,
  //     imgWidth: 1190,
  //     imgHeightTablet: 200,
  //     imgWidthTablet: 1190,
  //     imgHeightMobile: 240,
  //     imgWidthMobile: 320,
  //     imgAlt: 'May 20 Virtual Tasting',
  //     imgLink: '',
  //     linkCategory: '/shop/wine/may-20',
  //     backgroundColor: '#FFFFFF',
  //   },
  // },
  // 'may-22': {
  //   productCategories: ['wine'],
  //   category: 'may-22',
  //   filterCategory: 'wine',
  //   seoTitle: 'May 22',
  //   description: 'MAY 22 TASTING: ORDER BY 5/12',
  //   productsOnly: [
  //     'e03acb77-5676-48a6-bae7-a1997e39d5a6', // Carneros Reserve Chardonnay
  //     '51d193e5-0ee0-49c5-80c6-f47134e767f2', // Napa Valley Reserve Red Blend
  //   ],
  //   topBanner: {
  //     imgSrc: `${urlHomepageBackground}Virtual-Tasting-Main-Banner_desk.jpg`,
  //     imgSrcTablet: `${urlHomepageBackground}Virtual-Tasting-Main-Banner_desk.jpg`,
  //     imgSrcMobile: `${urlHomepageBackground}Virtual-Tasting-Main-Banner_mobile.jpg`,
  //     imgHeight: 200,
  //     imgWidth: 1190,
  //     imgHeightTablet: 200,
  //     imgWidthTablet: 1190,
  //     imgHeightMobile: 240,
  //     imgWidthMobile: 320,
  //     imgAlt: 'May 22 Virtual Tasting',
  //     imgLink: '',
  //     linkCategory: '/shop/wine/may-20',
  //     backgroundColor: '#FFFFFF',
  //   },
  // },
  // 'may-27': {
  //   productCategories: ['wine'],
  //   category: 'may-27',
  //   filterCategory: 'wine',
  //   seoTitle: 'May 27',
  //   description: 'MAY 27 TASTING: ORDER BY 5/15',
  //   productsOnly: [
  //     'f51a6c33-2089-4436-b5ff-c889967a0d66', // Monterey County Reserve Riesling
  //     '4e6d5f9b-5d40-4413-bb29-728d6437e799', // North Coast Reserve Muscat
  //     '7f19877a-dc31-4f8e-98cc-961bf018552f', // Monterey County Reserve Gewurztraminer
  //   ],
  //   topBanner: {
  //     imgSrc: `${urlHomepageBackground}Virtual-Tasting-Main-Banner_desk.jpg`,
  //     imgSrcTablet: `${urlHomepageBackground}Virtual-Tasting-Main-Banner_desk.jpg`,
  //     imgSrcMobile: `${urlHomepageBackground}Virtual-Tasting-Main-Banner_mobile.jpg`,
  //     imgHeight: 200,
  //     imgWidth: 1190,
  //     imgHeightTablet: 200,
  //     imgWidthTablet: 1190,
  //     imgHeightMobile: 240,
  //     imgWidthMobile: 320,
  //     imgAlt: 'May 27 Virtual Tasting',
  //     imgLink: 'https://www.facebook.com/pg/onehopewine/events/',
  //     linkCategory: '/shop/wine/may-27',
  //     backgroundColor: '#FFFFFF',
  //   },
  // },
  // 'may-29': {
  //   productCategories: ['wine'],
  //   category: 'may-29',
  //   filterCategory: 'wine',
  //   seoTitle: 'May 29',
  //   description: 'MAY 29 TASTING: ORDER BY 5/18',
  //   productsOnly: [
  //     'b1297bd5-a688-4575-b23c-d3cff95f2fc6', // Oakville Cabernet Sauvignon
  //     '175d0511-7951-4aea-a6a8-ac16ebfb2371', //CA Brut Sparkling Wine Silver Shimmer Edition
  //   ],
  //   topBanner: {
  //     imgSrc: `${urlHomepageBackground}Virtual-Tasting-Main-Banner_desk.jpg`,
  //     imgSrcTablet: `${urlHomepageBackground}Virtual-Tasting-Main-Banner_desk.jpg`,
  //     imgSrcMobile: `${urlHomepageBackground}Virtual-Tasting-Main-Banner_mobile.jpg`,
  //     imgHeight: 200,
  //     imgWidth: 1190,
  //     imgHeightTablet: 200,
  //     imgWidthTablet: 1190,
  //     imgHeightMobile: 240,
  //     imgWidthMobile: 320,
  //     imgAlt: 'May 29 Virtual Tasting',
  //     imgLink: 'https://www.facebook.com/pg/onehopewine/events/',
  //     linkCategory: '/shop/wine/may-29',
  //     backgroundColor: '#FFFFFF',
  //   },
  // },
  // 'may-29': {
  //   productCategories: ['wine'],
  //   category: 'may-29',
  //   filterCategory: 'wine',
  //   seoTitle: 'May 29',
  //   description: 'MAY 29 TASTING: ORDER BY 5/18',
  //   productsOnly: [
  //     'b1297bd5-a688-4575-b23c-d3cff95f2fc6', // Oakville Cabernet Sauvignon
  //     '175d0511-7951-4aea-a6a8-ac16ebfb2371', //CA Brut Sparkling Wine Silver Shimmer Edition
  //   ],
  //   topBanner: {
  //     imgSrc: `${urlHomepageBackground}Virtual-Tasting-Main-Banner_desk.jpg`,
  //     imgSrcTablet: `${urlHomepageBackground}Virtual-Tasting-Main-Banner_desk.jpg`,
  //     imgSrcMobile: `${urlHomepageBackground}Virtual-Tasting-Main-Banner_mobile.jpg`,
  //     imgHeight: 200,
  //     imgWidth: 1190,
  //     imgHeightTablet: 200,
  //     imgWidthTablet: 1190,
  //     imgHeightMobile: 240,
  //     imgWidthMobile: 320,
  //     imgAlt: 'May 29 Virtual Tasting',
  //     imgLink: 'https://www.facebook.com/pg/onehopewine/events/',
  //     linkCategory: '/shop/wine/may-29',
  //     backgroundColor: '#FFFFFF',
  //   },
  // },
  // 'june-3': {
  //   productCategories: ['wine'],
  //   category: 'june-3',
  //   filterCategory: 'wine',
  //   seoTitle: 'June 3',
  //   description: 'JUNE 3 TASTING: ORDER BY 5/22',
  //   productsOnly: [
  //     '5fa97b97-9b0c-4c4c-89ba-8458e2b4a856', // Vintner Collection California Chardonnay
  //     'e05b8a29-5be5-48a3-9034-42e8fc87a096', //Vintner Collection California Merlot
  //   ],
  //   ...banner,
  // },
  // 'june-5': {
  //   productCategories: ['wine'],
  //   category: 'june-5',
  //   filterCategory: 'wine',
  //   seoTitle: 'June 5',
  //   description: 'JUNE 5 TASTING: ORDER BY 5/26',
  //   productsOnly: [
  //     '82e2414a-0da0-4b46-852d-353a43705ea3', // California Rosé
  //     '4e6d5f9b-5d40-4413-bb29-728d6437e799', // North Coast Reserve Muscat
  //   ],
  //   ...banner,
  // },
  // 'june-10': {
  //   productCategories: ['wine'],
  //   category: 'june-10',
  //   filterCategory: 'wine',
  //   seoTitle: 'June 10',
  //   description: 'JUNE 10 TASTING: ORDER BY 5/29',
  //   productsOnly: [
  //     '06eb1bbd-2e89-4a75-86f7-8cca64c2d6d7', // Napa Valley Reserve Cabernet Sauvignon
  //     '21318bf0-779d-40a0-9810-0fd446c344f6', // Vintner Collection California Red Blend
  //   ],
  //   ...banner,
  // },
  // 'june-12': {
  //   productCategories: ['wine'],
  //   category: 'june-12',
  //   filterCategory: 'wine',
  //   seoTitle: 'June 12',
  //   description: 'JUNE 12 TASTING: ORDER BY 6/2',
  //   productsOnly: [
  //     '4b0ddac6-b7d7-4b74-9a3c-f7cc7bef34f5', // Celebration Brut Sparkling Wine Rainbow Edition
  //     '569b016d-aee4-4196-8dd9-526cdba57e22', // California Brut Sparkling Wine Rainbow Glitter Edition
  //   ],
  //   ...banner,
  // },
  // 'june-17': {
  //   productCategories: ['wine'],
  //   category: 'june-17',
  //   filterCategory: 'wine',
  //   seoTitle: 'June 17',
  //   description: 'JUNE 17 TASTING: ORDER BY 6/5',
  //   productsOnly: [
  //     '175d0511-7951-4aea-a6a8-ac16ebfb2371', // California Brut Sparkling Wine Silver Shimmer Edition
  //     'b1297bd5-a688-4575-b23c-d3cff95f2fc6', // Oakville Cabernet Sauvignon
  //   ],
  //   ...banner,
  // },
  // 'june-19': {
  //   productCategories: ['wine'],
  //   category: 'june-19',
  //   filterCategory: 'wine',
  //   seoTitle: 'June 19',
  //   description: 'JUNE 19 TASTING: ORDER BY 6/9',
  //   productsOnly: [
  //     'b502bd0b-73a0-4773-8f34-76941c4bce53', // Vintner Collection Cabernet Sauvignon
  //     '91dfc818-b39b-4547-980e-60a8e78ec5e9', // Vintner Collection California Sauvignon Blanc
  //   ],
  //   ...banner,
  // },
  // 'june-24': {
  //   productCategories: ['wine'],
  //   category: 'june-24',
  //   filterCategory: 'wine',
  //   seoTitle: 'June 24',
  //   description: 'JUNE 24 TASTING: ORDER BY 6/12',
  //   productsOnly: [
  //     '83028c43-87fe-4f3b-8956-a93573b2fff3', // Brut Millesimato DOC Prosecco
  //     '3a6488b1-dca5-4283-b1df-f3c6892997c0', // Rutherford Estate Cabernet Sauvignon - Blocks 1 & 5
  //   ],
  //   ...banner,
  // },
  // 'june-26': {
  //   productCategories: ['wine'],
  //   category: 'june-26',
  //   filterCategory: 'wine',
  //   seoTitle: 'June 26',
  //   description: 'JUNE 26 TASTING: ORDER BY 6/16',
  //   productsOnly: [
  //     '4b0ddac6-b7d7-4b74-9a3c-f7cc7bef34f5', // Celebration Brut Sparkling Wine Rainbow Edition
  //     '51d193e5-0ee0-49c5-80c6-f47134e767f2', // Napa Valley Reserve Red Blend
  //   ],
  //   ...banner,
  // },
  // 'july-1': {
  //   productCategories: ['wine'],
  //   category: 'july-1',
  //   filterCategory: 'wine',
  //   seoTitle: 'July 1',
  //   description: 'July 1 TASTING: ORDER BY 6/21',
  //   productsOnly: [
  //     '21318bf0-779d-40a0-9810-0fd446c344f6', // Vintner Collection California Red Blend
  //     '15b29dc0-27e0-4527-beda-01f1b09babe6', // Vintner Collection California Brut Sparkling
  //     '91dfc818-b39b-4547-980e-60a8e78ec5e9', // Vintner Collection Sauvignon Blanc
  //   ],
  //   ...banner,
  // },
  // 'july-8': {
  //   productCategories: ['wine'],
  //   category: 'july-8',
  //   filterCategory: 'wine',
  //   seoTitle: 'July 8',
  //   description: 'July 8 TASTING: ORDER BY 6/28',
  //   productsOnly: [
  //     '21318bf0-779d-40a0-9810-0fd446c344f6', // Vintner Collection California Red Blend
  //     '91dfc818-b39b-4547-980e-60a8e78ec5e9', // Vintner Collection Sauvignon Blanc
  //     '82e2414a-0da0-4b46-852d-353a43705ea3', // California Rosé
  //   ],
  //   ...banner,
  // },
  // 'july-10': {
  //   productCategories: ['wine'],
  //   category: 'july-10',
  //   filterCategory: 'wine',
  //   seoTitle: 'July 10',
  //   description: 'July 10 TASTING: ORDER BY 6/30',
  //   productsOnly: [
  //     '1717067c-6598-4c02-93ea-4626edb22fad', // Carneros Pinot Noir
  //     '5fa97b97-9b0c-4c4c-89ba-8458e2b4a856', // Vintner Collection California Chardonnay
  //   ],
  //   ...banner,
  // },
  'july-15': {
    productCategories: ['wine'],
    category: 'july-15',
    filterCategory: 'wine',
    seoTitle: 'July 15',
    description: 'July 15 TASTING: ORDER BY 7/5',
    productsOnly: [
      '1235adcf-6721-4f62-a56c-ea34712f5bcc', // Estate Napa Valley Moscato
      '301fdb0c-63d6-4f7c-8b59-11fa101f9ea3', // California Demi-Sec Pomegranate Flavored Sparkling Wine
      '894bc5f8-84b2-44e3-97d3-8599c9a7bc35', // California Demi-Sec Peach Flavored Sparkling Wine
    ],
    ...banner,
  },
  'july-17': {
    productCategories: ['wine'],
    category: 'july-17',
    filterCategory: 'wine',
    seoTitle: 'July 17',
    description: 'July 17 TASTING: ORDER BY 7/7',
    productsOnly: [
      'e05b8a29-5be5-48a3-9034-42e8fc87a096', // Vintner Collection California Merlot
      '57b8e318-ab33-4772-aef2-d213fe700147', // Rutherford Estate Sauvignon Blanc
    ],
    ...banner,
  },
  'july-22': {
    productCategories: ['wine'],
    category: 'july-22',
    filterCategory: 'wine',
    seoTitle: 'July 22',
    description: 'July 22 TASTING: ORDER BY 7/12',
    productsOnly: [
      'bfd8a609-5d28-4a4a-9558-78120d44a7b3', // Sonoma Reserve Rosé
      'aea4a77c-3b7b-4cd7-a471-9a1d1d70f2e8', // North Coast Reserve Sparkling Rosé
    ],
    ...banner,
  },
  // 'july-24': {
  //   productCategories: ['wine'],
  //   category: 'july-1',
  //   filterCategory: 'wine',
  //   seoTitle: 'July 24',
  //   description: 'Products Launching July 1',
  //   productsOnly: [
  //     'c64ed4dc-d3a9-465d-87f2-83a75485fa92', // North Coast Reserve Sparkling Brut
  //     '3a177b58-4117-44b2-901b-1edf413ceead', // North Coast Reserve Zinfandel
  //   ],
  //   ...banner,
  // },
  'july-29': {
    productCategories: ['wine'],
    category: 'july-29',
    filterCategory: 'wine',
    seoTitle: 'July 29',
    description: 'July 29 TASTING: ORDER BY 7/19',
    productsOnly: [
      'f9c3026b-f405-441a-ad07-95b3840015f5', // California Viognier
      '1cbd86c4-6481-43f2-923f-d1209766f352', // California Symphony
    ],
    ...banner,
  },
  'july-31': {
    productCategories: ['wine'],
    category: 'july-31',
    filterCategory: 'wine',
    seoTitle: 'July 31',
    description: 'July 31 TASTING: ORDER BY 7/21',
    productsOnly: [
      'c6120223-b875-4573-9db1-52828e835ffe', // Vintner Collection California Pinot Noir
      '25c13de4-e977-4845-97ee-c057d220b59a', // Vintner Collection California Pinot Grigio
    ],
    ...banner,
  },
  'august-5': {
    productCategories: ['wine'],
    category: 'august-5',
    filterCategory: 'wine',
    seoTitle: 'August 5',
    description: 'August 5 TASTING: ORDER BY 7/28',
    productsOnly: [
      '06eb1bbd-2e89-4a75-86f7-8cca64c2d6d7', // Napa Valley Reserve Cabernet Sauvignon
      'c6120223-b875-4573-9db1-52828e835ffe', // Vintner Collection California Pinot Noir
    ],
    ...banner,
  },
  'august-12': {
    productCategories: ['wine'],
    category: 'august-12',
    filterCategory: 'wine',
    seoTitle: 'August 12',
    description: 'August 12 TASTING: ORDER BY 8/4',
    productsOnly: [
      'bfd8a609-5d28-4a4a-9558-78120d44a7b3', // Sonoma Reserve Rosé
      '1717067c-6598-4c02-93ea-4626edb22fad', // Carneros Pinot Noir
    ],
    ...banner,
  },
  'august-19': {
    productCategories: ['wine'],
    category: 'august-19',
    filterCategory: 'wine',
    seoTitle: 'August 19',
    description: 'August 19 TASTING: ORDER BY 8/11',
    productsOnly: [
      '91dfc818-b39b-4547-980e-60a8e78ec5e9', // Vintner Collection Sauvignon Blanc
      'e05b8a29-5be5-48a3-9034-42e8fc87a096', //Vintner Collection California Merlot
    ],
    ...banner,
  },
  'august-26': {
    productCategories: ['wine'],
    category: 'august-26',
    filterCategory: 'wine',
    seoTitle: 'August 26',
    description: 'August 26 TASTING: ORDER BY 8/18',
    productsOnly: [
      '633351c2-a9a3-4c43-bfc9-470d3253756d', // Paso Robles Reserve Cabernet Sauvignon
      'aea4a77c-3b7b-4cd7-a471-9a1d1d70f2e8', // North Coast Reserve Sparkling Rosé
    ],
    ...banner,
  },
  'wine-best-selling': {
    productCategories: ['wine'],
    category: 'wine-best-selling',
    filterCategory: 'wine',
    seoTitle: 'Best Selling Wine',
    description: 'Best Selling Wine',
    productsOnly: [
      wines.brut,
      wines.chardonnay,
      wines.brutGlitterRainbow,
      '101b194b-106f-4f2c-89eb-f5109fc966b8', // Gold Glitter
      '91dfc818-b39b-4547-980e-60a8e78ec5e9', // Vintner Sauvignon Blanc
      'b502bd0b-73a0-4773-8f34-76941c4bce53', // Vintner Cabernet
      '83028c43-87fe-4f3b-8956-a93573b2fff3', // Prosecco
      '21318bf0-779d-40a0-9810-0fd446c344f6', // Vintner Red Blend
      '5ea58838-ac34-4d14-9db7-999a696e6a5e', // Silver Glitter
      'e05b8a29-5be5-48a3-9034-42e8fc87a096', // Vintner Merlot
      wines.cotesDeProvenceRose,
      wines.brutShimmerGold,
      wines.brutShimmerSilver,
    ],
  },
  'mixed-packs': {
    productCategories: ['wine'],
    category: 'mixed-packs',
    filterCategory: 'wine',
    seoTitle: 'Mixed Packs',
    description: 'Mixed Packs',
    productsOnly: [
      'fd6d86d5-edaf-4fbd-ae03-8b89b0910dad', // Award Winning Mixed Pack
      '6fd66553-877a-4a80-b432-1f099af6c797', // Best Sellers Mixed Pack
      'bdba3765-04c0-466e-9312-9ff0748eac9a', // Winters Mixed Pack
    ],
  },
  'gifts-best-selling': {
    productCategories: ['gift'],
    category: 'gifts-best-selling',
    filterCategory: 'gift',
    seoTitle: 'Best Selling Gifts',
    description: 'Best Selling Gifts',
    productsOnly: [
      giftBox.celebration,
      giftBox.woof,
      '97721a81-92a0-42e0-9bac-2931cf48ec34', // Birthday Babe 19
      giftBox.redWine,
      giftBox.worldGood,
      giftBox.frose,
      'e6f56bb7-704b-468d-9a55-4c8f74611781', // Single Bottle Wood 19
      giftBox.cookiesCab,
      giftBox.californian,
      giftBox.awwBaby,
    ],
  },
  'mothers-day-gifts-2019': {
    productCategories: ['gifts'],
    category: 'mothers-day-gifts-2019',
    filterCategory: 'gifts',
    seoTitle: 'Gifts for Mom',
    description: 'Grapeful Club Exclusive Etched Gifts for Mom',
    productsOnly: [
      giftBox.mothersDayDoubleBox19,
      giftBox.mothersDaySingleBox19,
    ],
    // topBanner: {
    //   imgSrc: `${urlHomepageBackground}SpringSale19_category_enddate_desktop.jpg`,
    //   imgSrcMobile: `${urlHomepageBackground}SpringSale19_category_enddate_mobile.jpg`,
    //   imgHeight: 200,
    //   imgWidth: 1190,
    //   imgHeightMobile: 240,
    //   imgWidthMobile: 320,
    //   imgAlt: 'Sip into Spring Sale!',
    //   imgLink: '/the-grapeful-club',
    //   linkCategory: 'sip-into-spring-sale',
    //   backgroundColor: '#FFFFFF',
    // },
  },
  /*
  Seasonal Guides
  */
  'guide-for-dads': {
    productCategories: ['wines', 'gifts'],
    category: 'guide-for-dads',
    filterCategory: 'none',
    seoTitle: 'Gifts for Dads',
    description: 'Gifts for Dads',
    productsOnly: [
      '29b5a039-c04a-484f-b9a8-3d0d23cb33c8', //Cookies & Cab Gift Box
      '2d1acd3e-f87f-46b1-b520-52ed70195165', // Single Magnetic Gift Box
      '838c1665-8fc3-4604-bdac-19867bda7e26', // 2-Bottle Wood Gift Box
      '633351c2-a9a3-4c43-bfc9-470d3253756d', // Paso Robles Reserve Cabernet Sauvignon
      'b1297bd5-a688-4575-b23c-d3cff95f2fc6', // Oakville Cabernet Sauvignon
      '06eb1bbd-2e89-4a75-86f7-8cca64c2d6d7', // Napa Valley Reserve Cabernet Sauvignon
      'b502bd0b-73a0-4773-8f34-76941c4bce53', // Vintner Collection Cabernet Sauvignon
      '21318bf0-779d-40a0-9810-0fd446c344f6', // Vintner Collection California Red Blend
    ],
    // topBanner: {
    //   imgSrc: `${urlHomepageBackground}Fathers-Day-Shop-Banner-v2-2020_desktop.jpg`,
    //   imgSrcTablet: `${urlHomepageBackground}Fathers-Day-Shop-Banner-v2-2020_desktop.jpg`,
    //   imgSrcMobile: `${urlHomepageBackground}Fathers-Day-Shop-Banner-2020_mobile.jpg`,
    //   imgHeight: 200,
    //   imgWidth: 1190,
    //   imgHeightTablet: 200,
    //   imgWidthTablet: 1190,
    //   imgHeightMobile: 240,
    //   imgWidthMobile: 320,
    //   imgAlt: 'Gifts for Dad',
    //   linkCategory: '/shop/guide-for-dads',
    //   backgroundColor: '#FFFFFF',
    // },
  },
  'guide-for-moms': {
    productCategories: ['wines', 'gifts'],
    category: 'guide-for-moms',
    filterCategory: 'none',
    seoTitle: 'Gifts for Moms',
    description: 'Gifts for Moms',
    productsOnly: [
      // giftBox.mothersDaySingleBox19,
      // giftBox.mothersDayDoubleBox19,
      giftBox.frose,
      // giftBox.roseMacrame,
      // giftBox.givingKeys,
      // giftBox.brunchBubbly,
      giftBox.woof,
      giftBox.meow,
      giftBox.wineHydrate,
      giftBox.singleMag,
      giftBox.twoMag,
      // giftBox.awwBaby,
      // giftBox.goodKarma,
      // giftBox.wineGrind,
      // giftBox.greenThumb,
      // giftBox.mixologist,
      // giftBox.whiteWine,
      giftCrate.deluxeDuo,
      giftCrate.picnicPerfect,
      merch.goldWaterBottle,
      wines.brutShimmerGold,
      wines.brutShimmerSilver,
      wines.brutCelebrationGlitterGold,
      wines.brutCelebrationGlitterSilver,
      wines.cotesDeProvenceRose,
    ],
    // topBanner: {
    //   imgSrc: `${urlHomepageBackground}Mothers-Day-Shop-Banner-v2-2020_desktop.jpg`,
    //   imgSrcTablet: `${urlHomepageBackground}Mothers-Day-Shop-Banner-v2-2020_desktop.jpg`,
    //   imgSrcMobile: `${urlHomepageBackground}Mothers-Day-Shop-Banner-v2-2020_mobile.jpg`,
    //   imgHeight: 200,
    //   imgWidth: 1190,
    //   imgHeightTablet: 200,
    //   imgWidthTablet: 1190,
    //   imgHeightMobile: 240,
    //   imgWidthMobile: 320,
    //   imgAlt: 'Sip into Spring Sale!',
    //   imgLink: '',
    //   linkCategory: 'sip-into-spring-sale',
    //   backgroundColor: '#FFFFFF',
    // },
  },
  'guide-for-guys': {
    productCategories: ['wine-collection-iconic', 'gift-box'],
    category: 'guide-for-guys',
    filterCategory: 'none',
    seoTitle: 'Gifts for Guys',
    description: 'Gifts for Guys',
    productsOnly: [
      'a2cb59d4-bd8e-4589-86ea-89afb49898c7', // Morning Man
      giftBox.wineGrind,
      'ce80d72a-3916-4f51-9a5e-9499a9adcc18', // Day of Golf 19
      wines.estateCab1,
      wines.estateCab2,
      wines.howellCab,
      wines.oakvilleCab,
    ],
  },
  'guide-for-gals': {
    productCategories: ['gifts'],
    category: 'guide-for-gals',
    filterCategory: 'none',
    seoTitle: 'Gifts for Gals',
    description: 'Gifts for Gals',
    productsOnly: [
      giftBox.frose,
      giftBox.roseMacrame,
      giftBox.givingKeys,
      '47c24511-fa8b-4326-a072-692235d69d24', // Sweet Tooth Mini 17
      giftBox.californian,
    ],
  },
  'guide-for-pet-lovers': {
    productCategories: ['wines', 'gift'],
    category: 'guide-for-pet-lovers',
    filterCategory: 'none',
    seoTitle: 'Gifts for Pet Lovers',
    description: 'Gifts for Pet Lovers',
    productsOnly: [
      'c6120223-b875-4573-9db1-52828e835ffe', // Vintner Pinot Noir
      '25c13de4-e977-4845-97ee-c057d220b59a', // Vintner Pinot Grigio
      'e001b6d2-1d9d-4294-bf10-f348c5df9ce8', // Italian Pinot Grigio
      // '91b2e0c7-07be-4e06-967c-4d84404800ee', // Single Bottle Wood Pinot Grigio (Sold Out)
      'c6120223-b875-4573-9db1-52828e835ffe', // Single Bottle Wood 19 Pinot Noir
      giftBox.woof,
      giftBox.meow,
      '9c8310a8-5a59-40cd-9f03-c7039df351e6', // The Walker 19
      '45fe7760-f807-4e0d-8622-c97d3c66d9ee', // Woof Crate 19
    ],
  },
  'guide-for-teachers': {
    productCategories: ['wine', 'gifts'],
    category: 'guide-for-teachers',
    filterCategory: 'none',
    seoTitle: 'Gifts for Teachers',
    description: 'Gifts for Teachers',
    productsOnly: [
      giftBox.peppermint,
      wines.cabMagnum,
      wines.tenYrCaliCab,
      wines.tenYrNapaCab,
      wines.brutCelebrationGlitterGold,
      'e03acb77-5676-48a6-bae7-a1997e39d5a6', // Carneros Chardonnay
      giftBox.cookiesCab,
      '588a7773-dd2d-4e37-821c-61f57393e4fb', // Picnic Perfect 19
      'e95a4f33-45c6-4b71-99fe-3131537045c2', // Just Because Mini 17
      '94647492-a188-4187-b050-ce1f32004914', // Great Crate 18
    ],
  },
  'guide-for-the-host': {
    productCategories: ['gift', 'kitchen'],
    category: 'guide-for-the-host',
    filterCategory: 'none',
    seoTitle: 'Gifts for the Host',
    description: 'Gifts for the Host',
    productsOnly: [
      // '9dcf0876-bb51-4f3e-b7a0-688d2871620c', // Christmas 17
      giftBox.celebration,
      giftCrate.wineCheese,
      giftBox.frose,
      giftBox.californian,
      giftBox.mixologist,
      giftBox.peppermint,
      '7fb99e2e-bf69-46f8-89ca-2f3b4e546985', // Oil and Vinegar
      '97f649b5-79f8-4994-8a4b-829c2ac25fe3', // Pasta and Bruschetta
      'a42e6dd2-e298-4b8e-a4c5-867cd799504f', // Savory Sauces
      '371dbfb4-fb83-44a2-a8f6-aaa79bdbf983', // Napa Taster
    ],
  },
  'guide-for-cabernet': {
    productCategories: ['wine-cabernet', 'gift'],
    category: 'guide-for-cabernet',
    filterCategory: 'none',
    seoTitle: 'Gifts for Cabernet Lovers',
    description: 'Gifts for Cabernet Lovers',
    productsOnly: [
      '254cd616-6697-4675-9e7a-13ac42602958', // Single Bottle Wood 19 Cabernet
      '1c6ce578-625d-4289-b919-098ece475538', // Red Wine Cabernet 18
      giftBox.cookiesCab,
      wines.cabMagnum,
      wines.tenYrCaliCab,
      wines.tenYrNapaCab,
      wines.estateCab1,
      wines.estateCab2,
      wines.howellCab,
      wines.oakvilleCab,
    ],
  },
  'valentines-day': {
    productCategories: ['gift'],
    category: 'valentines-day',
    filterCategory: 'none',
    seoTitle: 'Gifts for Valentine’s Day',
    description: 'Gifts for Valentine’s Day',
    productsOnly: [
      'fee4b3c7-79a3-4f2d-89fd-1faadae6dc6c', // Valentine’s Day Etched Two-Bottle Wood Gift Box Set
      'fd27e797-afc1-4583-ad48-0e116f085e5f', // Valentine’s Day Etched Single-Bottle Wood Gift Box Set
    ],
  },
  //pridePromo2019:
  'pride-promo': {
    productCategories: ['wine'],
    category: 'pride-promo',
    filterCategory: 'none',
    seoTitle: 'Shop Our Pride Promotion',
    description: '',
    productsOnly: [
      '75bc710a-9799-45fc-a75d-eb3d284fcac1', //Pride 4Pack
      '09d66083-dfc0-45ce-8753-4eaea9c2a6d6', //Rainbow Brut PC
      '569b016d-aee4-4196-8dd9-526cdba57e22', //Rainbow Brut Regular
      '60c850ab-27bd-4430-a113-0139647ed2e1', //Celebration Brut Rainbow NG
      'ba683e32-a331-4711-b181-6a7a5f9f4e8f', //Pride Box
    ],
  },
  // Virtual Tasting Support
  'annual-raise-the-barr': {
    productCategories: ['wine'],
    category: 'annual-raise-the-barr',
    filterCategory: 'none',
    seoTitle: 'Shop ',
    description: 'Raise The Barr - Annual Fundraiser & ONEHOPE Virtual Tasting',
    productsOnly: [
      '21318bf0-779d-40a0-9810-0fd446c344f6', // Vintner Collection California Red Blend
      '15b29dc0-27e0-4527-beda-01f1b09babe6', // Vintner Collection California Brut Sparkling
      'c6120223-b875-4573-9db1-52828e835ffe', // Vintner Collection California Pinot Noir
      '5fa97b97-9b0c-4c4c-89ba-8458e2b4a856', // Vintner Collection California Chardonnay

    ],
  },
  /*
  Marketing Sales
  */
  // 'sparkling-sale': {
  //   productCategories: ['wine'],
  //   category: 'sparkling-sale',
  //   filterCategory: 'wine',
  //   seoTitle: 'Sparkling Sale',
  //   description: 'Buy 3 or more of select sparkling wines, get 20% off',
  //   productsOnly: [
  //     '3a1c3a87-1573-41f3-84fd-7748c2643360', // Brut
  //     'b4210b34-0c4d-4e6d-8e96-12cb61340790', // Gold Shimmer *
  //     '791b3d82-4fad-4466-8511-bc1afbe026b8', // Gold Celebration *
  //     'd9d7b9c4-28b1-4ef4-8cc1-e63489d2a5bb', // Silver Celebraton *
  //     '101b194b-106f-4f2c-89eb-f5109fc966b8', // Gold Glitter *
  //     '569b016d-aee4-4196-8dd9-526cdba57e22', // Rainbow Glitter *
  //     '5ea58838-ac34-4d14-9db7-999a696e6a5e', // Silver Glitter *
  //     'f088e5b1-b19d-4d32-8a43-fdb3f54bf779', // 3x Silver Glitter *
  //     '3b4f51e7-7a63-4bab-9ce6-e9b359126504', // Celebration Brut
  //   ],
  // bottomBanner: {
  //   imgSrc: `${urlHomepageBackground}hero_flashsale.jpg`,
  //   imgSrcMobile: `${urlHomepageBackground}hero_flashsale_mobile.jpg`,
  //   imgHeight: 607,
  //   imgHeightMobile: 700,
  //   imgWidth: 1943,
  //   imgWidthMobile: 640,
  //   imgAlt: 'Glitter Bottle Sale, Save up to $195',
  //   imgLink: '/shop/flash-sale',
  //   linkCategory: 'flash-sale',
  //   backgroundColor: '#FFFFF',
  // },
  // },
  // 'flash-sale': {
  //   productCategories: ['wine'],
  //   category: 'flash-sale',
  //   filterCategory: 'none',
  //   seoTitle: 'Flash Sale',
  //   description: 'Glitter Flash Sale - Now through Dec 14th!',
  //   productsOnly: [
  //     '4629dc8b-487e-4f79-b2f4-6a82c4374d6d', // Glitter Collection 6-pack
  //     'ecf79cc7-b0bf-43b8-968c-5daa4b5926cb', // Glitter Collection 3-pack
  //   ],
  // },
  // 'black-friday-sale': {
  //   productCategories: ['wine'],
  //   category: 'black-friday-sale',
  //   filterCategory: 'wine',
  //   seoTitle: 'Black Friday Sale',
  //   description:
  //     'Buy 6 or more bottles, get 40% off and shipping is included *Glitters only include shipping, Reds in the Iconic Collection excluded',
  //   productsExclude: [
  //     'ac671d44-44c7-44bd-aba9-712cf4ed675f', // gold glitter 187ml
  //     'cbb0b2a1-8544-40b1-b472-44d0eb6ac36b', // silver glitter 187ml
  //     'f3e1b6b3-406e-43d2-a377-ecdc103d82f3', // reds mixed pack
  //     'c22c5ff9-6a0a-443e-bdae-b7ad25416ef2', // whites mixed pack
  //     '27989eba-e65e-4280-9cc0-7867e7e1b9dd', // holiday mixed pack
  //     'e95d0b0b-28e4-476a-ac56-e3f8169cc1ca', // best of california mixed pack
  //     'e8ddd5cc-d668-4ecf-9546-9cbcbf246b59', // 1.5L Cabernet
  //     wines.tenYrCaliCab,
  //     wines.tenYrNapaCab,
  //     '3a6488b1-dca5-4283-b1df-f3c6892997c0', // Estate Cab 1-5
  //     'c1ae37ad-8d18-4dea-93fb-b20e94661c47', // Estate Cab 2
  //     '4b795e81-8592-476e-a3c2-b61aa8b9c094', // Howell Mountain Cab
  //     'b1297bd5-a688-4575-b23c-d3cff95f2fc6', // Oakville Cab
  //     'b4210b34-0c4d-4e6d-8e96-12cb61340790', // Gold Shimmer
  //     '791b3d82-4fad-4466-8511-bc1afbe026b8', // Gold Celebration
  //     'd9d7b9c4-28b1-4ef4-8cc1-e63489d2a5bb', // Silver Celebraton
  //     '89416889-2235-4497-af34-a25ad9ad5434', // Red Edna Glitter 14
  //     '101b194b-106f-4f2c-89eb-f5109fc966b8', // Gold Glitter
  //     '569b016d-aee4-4196-8dd9-526cdba57e22', // Rainbow Glitter
  //     '5ea58838-ac34-4d14-9db7-999a696e6a5e', // Silver Glitter
  //     'f088e5b1-b19d-4d32-8a43-fdb3f54bf779', // 3x Silver Glitter
  //   ],
  // },
  // 'thanksgiving-sale': {
  //   productCategories: ['wine'],
  //   category: 'wine',
  //   seoTitle: 'Thanksgiving Sale',
  //   description: 'Buy 6+ Bottles and Shipping is Included',
  //   productsExclude: [
  //     'ac671d44-44c7-44bd-aba9-712cf4ed675f', // gold glitter 187ml
  //     'cbb0b2a1-8544-40b1-b472-44d0eb6ac36b', // silver glitter 187ml
  //     'f3e1b6b3-406e-43d2-a377-ecdc103d82f3', // reds mixed pack
  //     'c22c5ff9-6a0a-443e-bdae-b7ad25416ef2', // whites mixed pack
  //     '27989eba-e65e-4280-9cc0-7867e7e1b9dd', // holiday mixed pack
  //     'e95d0b0b-28e4-476a-ac56-e3f8169cc1ca', // best of california mixed pack
  //     'e8ddd5cc-d668-4ecf-9546-9cbcbf246b59', // 1.5L Cabernet
  //     wines.tenYrCaliCab,
  //     wines.tenYrNapaCab,
  //   ],
  // },
};
